import { memo } from "react";
import useTableCtx from "../tableContext/useTableCtx";
import TableRows from "./TableRows";

function TableBody({
  ActionButtonsComponent,
}: {
  ActionButtonsComponent: any;
}) {
  const { tableData } = useTableCtx()!;

  return (
    <tbody>
      <TableRows
        tableData={tableData}
        ActionButtonsComponent={ActionButtonsComponent}
      />
    </tbody>
  );
}

export default memo(TableBody);
